import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {AssessmentService} from "../../../services/assessment.service";
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import {DialogService} from "../../../services/dialog.service";

@Component({
  selector: 'app-barc-request',
  templateUrl: './barc-request.component.html',
  styleUrl: './barc-request.component.scss',
  standalone: false
})
export class BarcRequestComponent implements OnInit {

  barcForm: FormGroup = this.formBuilder.group({
    fire_id: [''],
    lat: [''],
    lon: [''],
    ignition_date: [null] as unknown as Date[],
    burned_acres: [''],
    expected_containment_date: [null] as unknown as Date[],
    comments: ['']
  });
  mergeList: any[] = [];
  est_nfs_acres_total = 0;
  total_fire_acres_total = 0;
  displayedColumns = [
    'BAER_name',
    'forestOrgCode',
    'fireId',
    'containment_date',
    'lat',
    'lon',
    'est_nfs_acres',
    'fire_acres',
  ];
  barcRequested = false;
  readonly fireRecord: any = this.data.fireRecord;
  readonly faArrowUpRightFromSquare = faArrowUpRightFromSquare;

  constructor(
    public dialogRef: MatDialogRef<BarcRequestComponent>,
    private readonly formBuilder: FormBuilder,
    private readonly assessmentService: AssessmentService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly dialogService: DialogService,
  ) {
  }

  ngOnInit() {
    this.barcRequested = this.fireRecord.barc_image_requested;
    this.barcForm.patchValue({
      ignition_date: this.fireRecord.fire_discovery_date ? new Date(this.fireRecord.fire_discovery_date) : undefined,
      burned_acres: this.fireRecord.total_fire_acres ?? '',
      expected_containment_date: this.fireRecord.containment_date_est ? new Date(this.fireRecord.containment_date_est) : undefined
    }, {emitEvent: true});
    if (this.fireRecord.source === 'GIS') {
      this.barcForm.patchValue({
        fire_id: this.fireRecord.IRWIN_unique_fire_identifier ?? '',
        lat: this.fireRecord.initial_latitude ?? '',
        lon: this.fireRecord.initial_longitude ?? '',
      }, {emitEvent: true});
    }
    if (this.fireRecord.source === 'MERGE') {
      this.assessmentService.getAssessmentMergeList(this.fireRecord.assessment_id).subscribe(data => {
        this.mergeList = data.assessments;
        this.mergeList.forEach((fire: any) => {
          this.est_nfs_acres_total += fire.acres_fsonly || 0;
          this.total_fire_acres_total += fire.poly_acres || 0;
        });
      });
    }
    if (this.barcRequested) {
      this.barcForm.disable();
    }
  }

  onSubmit() {
    this.dialogService.openSpinner();
    const payload = {
      "assessment_id": this.fireRecord.assessment_id,
      "fire_id": this.barcForm.controls?.['fire_id']?.value,
      "latitude": Number(this.barcForm.controls?.['lat']?.value ?? 0.0),
      "longitude": Number(this.barcForm.controls?.['lon']?.value ?? 0.0),
      "fire_start_date": this.getCompliantDate(this.barcForm.controls?.['ignition_date']?.value),
      "burned_acres": Number(this.barcForm.controls?.['burned_acres']?.value ?? 0.0),
      "expected_containment_date": this.getCompliantDate(this.barcForm.controls?.['expected_containment_date']?.value),
      "comments": this.barcForm.controls?.['comments']?.value
    }
    this.assessmentService.requestBarcImage(payload).subscribe({
      next: () => {
        this.dialogService.closeSpinner();
        this.dialogRef.close('success');
      },
      error: () => {
        this.dialogService.closeSpinner();
        this.dialogRef.close('error');
      }
    });
  }

  private getCompliantDate(rawDate: string): string | undefined {
    return rawDate ? new Date(rawDate).toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      timeZone: 'UTC'
    }) : undefined;
  }
}
